import { apiRequest } from "./client";

const base = (guildId) => `/api/v1/guilds/${guildId}/tickets`;

export const getTickets = (guildId, status) =>
  apiRequest(`${base(guildId)}${status ? `?status=${status}` : ""}`);
export const getTicketConfig = (guildId) => apiRequest(`${base(guildId)}/config`);
export const updateTicketConfig = (guildId, payload) =>
  apiRequest(`${base(guildId)}/config`, { method: "PATCH", body: payload });

export const getTicketPanel = (guildId) => apiRequest(`${base(guildId)}/panel`);
export const sendTicketPanel = (guildId, payload) =>
  apiRequest(`${base(guildId)}/panel/send`, { method: "POST", body: payload });
export const updateTicketPanel = (guildId, payload) =>
  apiRequest(`${base(guildId)}/panel`, { method: "PATCH", body: payload });
export const deleteTicketPanel = (guildId) =>
  apiRequest(`${base(guildId)}/panel`, { method: "DELETE" });

export const getTicketOptions = (guildId) => apiRequest(`${base(guildId)}/options`);
export const createTicketOption = (guildId, payload) =>
  apiRequest(`${base(guildId)}/options`, { method: "POST", body: payload });
export const updateTicketOption = (guildId, optionId, payload) =>
  apiRequest(`${base(guildId)}/options/${optionId}`, { method: "PATCH", body: payload });
export const deleteTicketOption = (guildId, optionId) =>
  apiRequest(`${base(guildId)}/options/${optionId}`, { method: "DELETE" });

export const getTicketCategories = (guildId) => apiRequest(`${base(guildId)}/categories`);
export const createTicketCategory = (guildId, name) =>
  apiRequest(`${base(guildId)}/categories`, { method: "POST", body: { name } });
export const renameTicketCategory = (guildId, categoryId, name) =>
  apiRequest(`${base(guildId)}/categories/${categoryId}`, { method: "PATCH", body: { name } });
export const deleteTicketCategory = (guildId, categoryId) =>
  apiRequest(`${base(guildId)}/categories/${categoryId}`, { method: "DELETE" });

export const getTicketLogs = (guildId) => apiRequest(`${base(guildId)}/logs`);
export const updateTicketLogs = (guildId, channelId) =>
  apiRequest(`${base(guildId)}/logs`, { method: "PATCH", body: { channel_id: channelId } });

export const getTicketOverview = (guildId) => apiRequest(`${base(guildId)}/overview`);

export const ticketAction = (guildId, channelId, action) =>
  action === "delete"
    ? apiRequest(`${base(guildId)}/${channelId}`, { method: "DELETE" })
    : apiRequest(`${base(guildId)}/${channelId}/${action}`, { method: "POST" });
